import { useState, useEffect } from 'react';

interface Organization {
  id: string;
  name: string;
  type: string;
  created_at: string;
}

interface UseOrganizationReturn {
  organization: Organization | null;
  loading: boolean;
  error: string | null;
  isOfficialOrganization: boolean;
  isChurchOrganization: boolean;
  hasChurchAccess: boolean;
}

export const useOrganization = (): UseOrganizationReturn => {
  const [organization, setOrganization] = useState<Organization | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const getTokenFromCookies = () => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'sgo_access_token') {
        return value;
      }
    }
    return null;
  };

  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const token = getTokenFromCookies();
        if (!token) {
          setError('Token de autenticação não encontrado');
          setLoading(false);
          return;
        }

        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3030';
        const response = await fetch(`${API_BASE_URL}/organizations/my`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          setOrganization(data.data);
        } else if (response.status === 401) {
          // Token inválido ou expirado, redirecionar para login
          window.location.href = '/signin';
        } else {
          setError('Erro ao buscar organização');
        }
      } catch (err) {
        setError('Erro ao conectar com a API');
      } finally {
        setLoading(false);
      }
    };

    fetchOrganization();
  }, []);

  const isOfficialOrganization = organization?.type === 'oficial_organization';
  const isChurchOrganization = organization?.type === 'church';
  const hasChurchAccess = isOfficialOrganization || isChurchOrganization;

  return {
    organization,
    loading,
    error,
    isOfficialOrganization,
    isChurchOrganization,
    hasChurchAccess
  };
};